import { defineMessages } from 'react-intl';

/**
 * Address form message descriptors. Lifted from sslite so both sslite and
 * ss-ui-client can consume the same form component. Each consumer's
 * formatjs extract pipeline must include `client-common/src/**` so these
 * messages flow into their compiled locale bundles.
 */
export const addressFormMessages = defineMessages({
  name: {
    defaultMessage: 'Name',
    id: 'C04fkc',
    description: 'Label for name field in address form',
  },
  companyName: {
    defaultMessage: 'Company',
    id: 'D223cT',
    description: 'Label for company name field in address form',
  },
  companyPlaceholder: {
    defaultMessage: 'Company Name',
    id: 'fOzH3L',
    description: 'Placeholder for company name field',
  },
  addressLine1: {
    defaultMessage: 'Address',
    id: 'TYkHFn',
    description: 'Label for address line 1 field',
  },
  addressLine2: {
    defaultMessage: 'Address Line 2',
    id: '/q6Ztj',
    description: 'Label for address line 2 field',
  },
  addressLine3: {
    defaultMessage: 'Address Line 3',
    id: 'GxzFUV',
    description: 'Label for address line 3 field',
  },
  addressLine1Placeholder: {
    defaultMessage: 'Address Line 1',
    id: 'YaSO4d',
    description: 'Placeholder for address line 1',
  },
  addressLine2Placeholder: {
    defaultMessage: 'Address Line 2',
    id: 'csWXiD',
    description: 'Placeholder for address line 2',
  },
  addressLine3Placeholder: {
    defaultMessage: 'Address Line 3',
    id: '6rDfG2',
    description: 'Placeholder for address line 3',
  },
  city: {
    defaultMessage: 'City',
    id: 'jh4ZU+',
    description: 'Label for city field',
  },
  suburb: {
    defaultMessage: 'Suburb',
    id: 'UaAVu7',
    description: 'Label for suburb field (Australia)',
  },
  town: {
    defaultMessage: 'Town/City',
    id: 'hRybyX',
    description: 'Label for town/city field (New Zealand)',
  },
  state: {
    defaultMessage: 'State',
    id: 'JDnq1d',
    description: 'Label for state field',
  },
  county: {
    defaultMessage: 'County',
    id: '4PcryM',
    description: 'Label for county field (UK)',
  },
  province: {
    defaultMessage: 'Province',
    id: 'PooS0x',
    description: 'Label for province field (Canada)',
  },
  postalCode: {
    defaultMessage: 'Postal Code',
    id: 'nQ5Cj3',
    description: 'Label for postal code field',
  },
  zipCode: {
    defaultMessage: 'Zip Code',
    id: 'CffqoZ',
    description: 'Label for zip code field (US)',
  },
  postcode: {
    defaultMessage: 'Postcode',
    id: 'Tnbx04',
    description: 'Label for postcode field (UK/AU)',
  },
  country: {
    defaultMessage: 'Country',
    id: 'KHeiEH',
    description: 'Label for country field',
  },
  phone: {
    defaultMessage: 'Phone',
    id: 'CCZXAK',
    description: 'Label for phone number field',
  },
  email: {
    defaultMessage: 'Email',
    id: 'bGKAyO',
    description: 'Label for email field',
  },
  required: {
    defaultMessage: 'This field is required',
    id: 'PqNFdk',
    description: 'Error message for required field',
  },
  invalidEmail: {
    defaultMessage: 'Please enter a valid email address',
    id: 'N0LR2N',
    description: 'Error message for invalid email',
  },
  invalidPhone: {
    defaultMessage: 'Please enter a valid phone number',
    id: 'vGzajE',
    description: 'Error message for invalid phone',
  },
  invalidPostalCode: {
    defaultMessage: 'Please enter a valid postal code',
    id: 'FKbJ+8',
    description: 'Error message for invalid postal code',
  },
  maxLength: {
    defaultMessage: 'Maximum {max} characters allowed',
    id: 'lnL/zn',
    description: 'Error message for field exceeding maximum length',
  },
  loadingCountries: {
    defaultMessage: 'Loading countries...',
    id: 'iu5IvL',
    description: 'Placeholder while loading countries',
  },
  selectCountry: {
    defaultMessage: 'Select country',
    id: '4Nlmyz',
    description: 'Placeholder for country selector',
  },
  loadingStates: {
    defaultMessage: 'Loading...',
    id: 'PZaVKB',
    description: 'Placeholder while loading states',
  },
  selectState: {
    defaultMessage: 'Select',
    id: 'Kk6CeD',
    description: 'Placeholder for state selector',
  },
});
